const Strings = {
  SIGN_OUT: 'Logga ut',
  SIGN_OUT_HEADER: 'Är du säker på att du vill logga ut?',
  NO: 'Nej',
  YES: 'Ja'
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/strings.js